const CONTROL_CHARS_PATTERN = /[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F]/g;
const HTML_BRACKETS_PATTERN = /[<>]/g;
const MULTI_SPACE_PATTERN = /[^\S\r\n]+/g;
const MULTI_NEWLINE_PATTERN = /\n{3,}/g;

const NEUTRALIZED_SEQUENCES = [
  { pattern: /javascript\s*:/gi, replacement: "javascript " },
  { pattern: /vbscript\s*:/gi, replacement: "vbscript " },
  { pattern: /data\s*:\s*text\/html/gi, replacement: "data text/html" },
];

function normalizeUnsafeSequences(value) {
  return NEUTRALIZED_SEQUENCES.reduce(
    (currentValue, entry) => currentValue.replace(entry.pattern, entry.replacement),
    value
  );
}

export function sanitizeTextValue(value, options = {}) {
  const {
    multiline = false,
    maxLength,
    preserveWhitespace = false,
  } = options;
  const rawValue = String(value ?? "");

  let sanitizedValue = rawValue
    .normalize("NFKC")
    .replace(/\r\n?/g, "\n")
    .replace(CONTROL_CHARS_PATTERN, "");

  sanitizedValue = normalizeUnsafeSequences(sanitizedValue).replace(HTML_BRACKETS_PATTERN, "");

  if (multiline) {
    sanitizedValue = preserveWhitespace
      ? sanitizedValue
          .replace(/\u00A0/g, " ")
          .replace(MULTI_NEWLINE_PATTERN, "\n\n")
      : sanitizedValue
          .split("\n")
          .map((line) => line.replace(MULTI_SPACE_PATTERN, " ").trim())
          .join("\n")
          .replace(MULTI_NEWLINE_PATTERN, "\n\n")
          .trim();
  } else {
    sanitizedValue = sanitizedValue.replace(/\s+/g, " ").trim();
  }

  if (typeof maxLength === "number" && maxLength >= 0) {
    sanitizedValue = sanitizedValue.slice(0, maxLength);
  }

  return {
    value: sanitizedValue,
    changed: sanitizedValue !== rawValue,
  };
}

export function sanitizeSingleLineText(value, options = {}) {
  return sanitizeTextValue(value, { ...options, multiline: false }).value;
}

export function sanitizeMultilineText(value, options = {}) {
  return sanitizeTextValue(value, { ...options, multiline: true }).value;
}

export function sanitizeDeepStringValues(input) {
  if (typeof input === "string") {
    return sanitizeTextValue(input, {
      multiline: input.includes("\n"),
      preserveWhitespace: input.includes("\n"),
    }).value;
  }

  if (Array.isArray(input)) {
    return input.map((item) => sanitizeDeepStringValues(item));
  }

  if (input && Object.getPrototypeOf(input) === Object.prototype) {
    return Object.entries(input).reduce((result, [key, value]) => {
      result[key] = sanitizeDeepStringValues(value);
      return result;
    }, {});
  }

  return input;
}
